import React, { useEffect, useState } from "react";
import "./ratings.scss";
import { Col, Container, Row } from "reactstrap";
import Breadcrumb from "../../components/Common/Breadcrumb";
import { ToastContainer } from "react-toastify";
import Loading from "../../components/loading/Loading";
import axios from "axios";
import { Constants } from "src/Constants";
import Rating from "../../components/ratings/Rating";

function Ratings() {
  const [testimonies, setTestimonies ] = useState([])
  const [loading, setLoading ] = useState(false)
  const [add, setAdd ] = useState(false)
  const [newTestimony, setNewTestimony ] = useState({
    name: '',
    rating: '',
    description: '',
    image: null,
    created_at: new Date().toISOString().substring(0, 10)
  })

  const handleDelete = async (id: number) => {
    if(!window.confirm('Desea eliminar la reseña?')) return;
    setLoading(true)
    try {
      await axios.delete(`${Constants.BASE_URL}testimonies/${id}`)
      fetch()
      setAdd(false)
      setNewTestimony({
        name: '',
        rating: '',
        description: '',
        image: null,
        created_at: new Date().toISOString().substring(0, 10)
      })
      setLoading(false)
    } catch (error) {
      setLoading(false)
      throw error
    }
  }

  const handleAdd = async () => {
    if(!newTestimony?.name || !newTestimony?.rating || !newTestimony.description || !newTestimony.created_at){
      alert('Todos los campos son requeridos')
      return;
    }
    setLoading(true)
    try {
      await axios.post(`${Constants.BASE_URL}testimonies`, newTestimony)
      fetch()
      setLoading(false)
      setAdd(false)
      setNewTestimony({
        name: '',
        rating: '',
        description: '',
        image: null,
        created_at: new Date().toISOString().substring(0, 10)
      })
    } catch (error) {
      setLoading(false)
      throw error
    }
  }


  const fetch = async () => {
      setLoading(true)
      try {
        const resp = await axios.get(`${Constants.BASE_URL}testimonies/all`)
        setTestimonies(resp.data.testimonies)
        setLoading(false)
      } catch (error) {
        throw error
      }
  }

    useEffect(() => {
        fetch()
    }, [])

  return (
    <React.Fragment>
      <ToastContainer />
      {loading && <Loading />}
      <div className="page-content" id="Config">
        <Container fluid={true}>
          <Breadcrumb title="Rating" breadcrumbItem="Rating" />
          <Row style={{marginTop: 20}}>
            <Col>
                {add && <Rating newTestimony={newTestimony} setNewTestimony={setNewTestimony} handleAdd={handleAdd}  /> }
            </Col>
          </Row>
          <Row style={{ marginBottom: "2rem" }}>
            <Col>
                <div className="col-12 text-left d-flex gap-3">
                  <button
                    className="btn btn-primary waves-effect waves-light"
                    onClick={() => setAdd(!add)}
                  >
                    {
                      add ? 'Cancelar' : 'Agregar'
                    }
                  </button>
                  {
                    add ? <button
                    className="btn btn-success waves-effect waves-light"
                    onClick={handleAdd}
                  >
                    Guardar
                  </button> : null
                  }
                </div>
            </Col>
          </Row>
          <Row>
            <Col>
              {testimonies.map((testimony: any) => (
                  <Rating testimony={testimony} handleDelete={handleDelete} />
                ))}
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default Ratings;
